module.exports = __webpack_public_path__ + "media/images/setup_start_illustration-53a266b4cd673d57af00735870b38f80.svg";